import script from "./SelectCurrencyForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectCurrencyForm.vue?vue&type=script&setup=true&lang=js"

import "./SelectCurrencyForm.vue?vue&type=style&index=0&id=6fc54ec5&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fc54ec5"]])

export default __exports__